import React from 'react'
import InputGroup from './InputGroup.jsx'
import PropTypes from 'prop-types'

function Step1Investor({
  compact,
  handleInputChange,
  formValidation,
  formData,
  nextButton,
  disabledEmail,
}) {
  return (
    <div className="u-sm-sizeFull">
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="firstName"
        fieldId="firstName"
        label="First Name"
        compact={compact}
      />
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="lastName"
        fieldId="lastName"
        label="Last Name"
        compact={compact}
      />
      <InputGroup
        handleInputChange={handleInputChange}
        formValidation={formValidation}
        formData={formData}
        fieldName="emailId"
        fieldId="emailId"
        label="Email Address"
        compact={compact}
        disabled={disabledEmail}
      />
      {nextButton && nextButton()}
    </div>
  )
}

Step1Investor.propTypes = {
  compact: PropTypes.bool,
  handleInputChange: PropTypes.func.isRequired,
  formValidation: PropTypes.object,
  formData: PropTypes.object,
  nextButton: PropTypes.func,
}

export default Step1Investor
